import script from "./SoftBanCollections.vue?vue&type=script&setup=true&lang=js"
export * from "./SoftBanCollections.vue?vue&type=script&setup=true&lang=js"

export default script